/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_DemoteInputs */

const cs_gallery_demote = /** @type {(inputs: Gallery_DemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit publikaci`)
};

const en_gallery_demote = /** @type {(inputs: Gallery_DemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unpublish`)
};

/**
* | output |
* | --- |
* | "Unpublish" |
*
* @param {Gallery_DemoteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_demote = /** @type {((inputs?: Gallery_DemoteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_DemoteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_demote(inputs)
	return cs_gallery_demote(inputs)
});